<div *ngIf="this.form">
    <a (click)="onModalCancel()" class="close-button"><mat-icon class="close-icon">close</mat-icon></a>
    
    <div class="col-sm-8">
      <h3 *ngIf="!this.form.get('id').value">Ajouter une  famille</h3>
      <h3 *ngIf="this.form.get('id').value">Modifier une famille</h3>

    </div>
   
    <div class="col-sm-12">
      <mat-divider></mat-divider>
    </div>
    
    <form focusInvalidInput class="row" [formGroup]="this.form" style="display: flex; justify-content: space-between;">
        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>Code</mat-label>
            <input matInput type="text" name="code" formControlName="code" maxlength="8" required>
                <mat-error *ngIf="form.get('code').hasError('required')">
                Veuillez saisir un code
                </mat-error>
                <mat-error *ngIf="form.get('code').hasError('max')">
                    Le code est trop long
                </mat-error>
            </mat-form-field>
        </div>
        <div class="col-sm-12">
            <mat-form-field class="full-width">
            <mat-label>Libelle</mat-label>
            <input matInput name="libelle" formControlName="libelle" maxlength="30" required>
            <mat-error *ngIf="form.get('libelle').hasError('required')">
                Veuillez saisir un libelle
            </mat-error>
            <mat-error *ngIf="form.get('libelle').hasError('max')">
                Le libelle est trop long
            </mat-error>
            </mat-form-field>
        </div>
       
    </form>
    
  </div>
  
  <div class="col-sm-12 row" style="display: flex; justify-content: space-between;">
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button mat-raised-button color="default" (click)="onModalCancel()">Annuler</button>
    </div>
  
    <div class="col-sm-6 text-center" style="margin-top: 24px;">
      <button *ngIf="this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Modifier</button>
      <button *ngIf="!this.form.get('id').value" mat-raised-button color="success" (click)="onModalConfirm()">Ajouter</button>

    </div>
  </div>

